import { render, staticRenderFns } from "./esstialInformationTable.vue?vue&type=template&id=bca9a574&scoped=true&"
import script from "./esstialInformationTable.vue?vue&type=script&lang=js&"
export * from "./esstialInformationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca9a574",
  null
  
)

export default component.exports